// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"d319d44d","411":"4145ec48","466":"ecf489e0","592":"5b236df0","808":"ed62a91c"}[chunkId] + ".chunk.css";
};